// Define interfaces for custom emojis
export interface CustomEmoji {
  id: string;
  name: string;
  keywords: string[];
  skins: { src: string }[];
}

export interface CustomEmojiCategory {
  id: string;
  name: string;
  emojis: CustomEmoji[];
}

// Brand logos category
export const brandLogos: CustomEmojiCategory = {
  id: "brand-logos",
  name: "Brand Logos",
  emojis: [
    {
      id: "shopify",
      name: "Shopify",
      keywords: ["shop", "ecommerce", "store", "online"],
      skins: [{ src: "https://cdn.worldvectorlogo.com/logos/shopify.svg" }],
    },
    {
      id: "react",
      name: "React",
      keywords: ["javascript", "framework", "frontend"],
      skins: [
        {
          src: "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg",
        },
      ],
    },
    {
      id: "github",
      name: "GitHub",
      keywords: ["git", "code", "repository"],
      skins: [
        {
          src: "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        },
      ],
    },
    {
      id: "nextjs",
      name: "Next.js",
      keywords: ["javascript", "react", "framework"],
      skins: [{ src: "https://cdn.worldvectorlogo.com/logos/nextjs-2.svg" }],
    },
  ],
};

// Social media category
export const socialMedia: CustomEmojiCategory = {
  id: "social-media",
  name: "Social Media",
  emojis: [
    {
      id: "twitter",
      name: "Twitter/X",
      keywords: ["tweet", "social", "bird"],
      skins: [{ src: "https://cdn.worldvectorlogo.com/logos/twitter-6.svg" }],
    },
    {
      id: "instagram",
      name: "Instagram",
      keywords: ["photo", "social", "pics"],
      skins: [
        { src: "https://cdn.worldvectorlogo.com/logos/instagram-2016-5.svg" },
      ],
    },
    {
      id: "linkedin",
      name: "LinkedIn",
      keywords: ["professional", "network", "job"],
      skins: [
        { src: "https://cdn.worldvectorlogo.com/logos/linkedin-icon-2.svg" },
      ],
    },
  ],
};

// All custom emoji categories
export const allCustomEmojis: CustomEmojiCategory[] = [brandLogos, socialMedia];

// Default custom emojis for the picker
export const defaultCustomEmojis: CustomEmojiCategory[] = [brandLogos];
